import React, { Component, PropTypes } from 'react'

export class TriColumn extends Component {
  render() {
    return (
      <section className="section--lgrey">
        <div className="container">
          <div className="section__head">
            <h2>Culture and perks</h2>
            <p>
              {' '}
              Our superb benefits and perks are designed to help you grow and celebrate. We believe you should
              love what you do.
            </p>
          </div>
          <div className="section__body">
            <div className="row">
              <div className="column--third">
                <div className="card">
                  {/*<img />*/}
                  <div className="meta">
                    <h4>Health Care</h4>
                    <p>
                      Health, dental, vision and life insurance are heavily subsidized. Choice is key so we
                      offer 10+ options.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  {/*<img />*/}
                  <div className="meta">
                    <h4>Healthy Snacks</h4>
                    <p>
                      We partner with Eat Club to provide lunch on Friday and we’ll stock your favorite
                      nutritious snacks.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  {/*<img />*/}
                  <div className="meta">
                    <h4>Commuter Benefits</h4>
                    <p>
                      Life in Los Angeles revolves around traffic. Save money on public transportation via
                      WageWorks.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  {/*<img />*/}
                  <div className="meta">
                    <h4>Convenient Location</h4>
                    <p>
                      With multiple gyms within walking distance, being across the street from the beach has
                      its benefits.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  {/*<img />*/}
                  <div className="meta">
                    <h4>Paid Holidays</h4>
                    <p>
                      Paid holidays and unlimited vacation. Is your favorite game getting released soon?
                      You’ll get that day off.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card">
                  {/*<img />*/}
                  <div className="meta">
                    <h4>Game Room</h4>
                    <p>
                      Need to test out some in-game features? Pick your favorite PC and get your work done.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default TriColumn



// WEBPACK FOOTER //
// ./src/common/ui/components/triColumn__benefits.js